import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, { CChiamaWebParametri } from "src/ChiamaWeb";
import { Trad } from "src/components/";
import { CData } from "src/Data";
import useDerogation from "../../hooks/Derogation";
import { IRouteParam } from "../../pages/Policy";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";
import useToggle from "../../../hooks/Toggle";
import PrintIcon from "@material-ui/icons/Print";
import { onPrint } from "../Bond/helpers";
import { _ButtonAPI, _PolicyCARFormContent, _Derogation, _Button } from "../../components";
import { CreaClassePolizzaCar } from "src/Globale";

const Tax = 0.2125;

export const _PolicyCARForm: React.FC = () => {
    const history = useHistory();
    const { open, toggle } = useToggle();
    const { ID_Anag, ID_Polizza } = useParams<IRouteParam>();
    const { ShowDialog } = useContext(AlertDialogContext);
    const editingRights = Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura);
    const initialData = new Dati.CRisAPIDatoTipiInfo_Polizza();
    initialData.Dato.ID_AnagContraente = Number(ID_Anag);

    const [Data, setData] = useReducerOnChange<Dati.CRisAPIDatoTipiInfo_Polizza>(initialData);
    const [PolicyData, setPolicyData] = useReducerOnChange<any>({});
    const [ProductBinder, setProductBinder] = useState("");
    const [Limits, setLimits] = useState<Dati.Dictionary<number>>({});
    const { DerogationFieldsList, OnChangeDerogation } = useDerogation();


    useEffect(() => { GetData(); }, [ID_Anag, ID_Polizza]);

    useEffect(() => {
        if (ID_Polizza == '0' && Data.Dato.ID_TipoProdotto == 0) {
            GetNewPolicyData();
        }
    }, [Data.Dato.ID_TipoProdotto, ID_Polizza]);

    useEffect(() => { GetProductBinder(); }, [ID_Polizza, Data.Dato.ID_TipoProdotto, Data.Dato.DataEffetto]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/?id_Polizza=${ID_Polizza}&id_AnagContraente=${ID_Anag}&dataEffetto=${moment(Data.Dato.DataEffetto).utc().format()}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Tipi["BinderProdotto"].BinderProdotto.Valore) {
            setProductBinder(data.Tipi["BinderProdotto"].BinderProdotto.Valore);
        }
        if (data.ID_Chiave > 0) {
            const newPolicy: any = Glob.CreaClassePolizzaCar(data.Info);
            newPolicy.ProvCompagnia = 25;
            newPolicy.DataInizioManutenzione = null;
            newPolicy.DataFineManutenzione = null;
            const policyData: any = JSON.parse(data.Dato.DatiPolizza);

            for (let key in newPolicy) {
                if (policyData[key] != undefined) {
                    newPolicy[key] = policyData[key];
                }
                if ((key == "CExt1" || key == "CExt2" || key == "CExt3" || key == "CExt4" || key == "CExt5"
                    || key == "CExt6" || key == "CExt7" || key == "CExt8" || key == "CExt9" || key == "CExt10"
                    || key == "CExt11" || key == "CExt12")
                    && newPolicy[key] == "") {
                    newPolicy[key] = false;
                }
                if (key == "ImpegnoRilascio" && newPolicy[key] == "") {
                    newPolicy[key] = true;
                }
            }
            setData({ Type: "Set", Value: data });
            setPolicyData({ Type: "Set", Value: newPolicy });
        }
    };

    const GetNewPolicyData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetInfoPolizza?ID_TipoProdotto=${101}`,
            OnRis: OnGetNewPolicyData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetNewPolicyData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        let emptyPolicy: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
        emptyPolicy.Info = data.Info;
        emptyPolicy.Dato = Data.Dato;

        let newPolicy: any = Glob.CreaClassePolizzaCar(data.Info);
        newPolicy.LuogoEsecuzione = "Vedasi oggetto garanzia";
        newPolicy.DataInizioManutenzione = null;
        newPolicy.DataFineManutenzione = null;
        newPolicy.DataStipula = newPolicy.DataStipula;
        setData({ Type: "Set", Value: emptyPolicy });
        setPolicyData({ Type: "Set", Value: newPolicy });
    };

    const GetProductBinder = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetBinderProdotto?ID_AnagA=${Data.Dato.ID_AnagPOS}&ID_TipoProdotto=${Data.Dato.ID_TipoProdotto}&dataEffetto=${moment(Data.Dato.DataEffetto).utc().format()}`,
            OnRis: OnGetProductBinder,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetProductBinder = (sender: ChiamaWeb, data: Dati.CRisAPISemplice<string>) => {
        if (Data.Dato.CoAssicurazioneJSON != "") {
            setData({ Type: "OnChangeFromValue", Name: "Dato.CoAssicurazioneJSON", Value: Data.Dato.CoAssicurazioneJSON });
            setProductBinder(data.Dato);
        }
        else {
            setData({ Type: "OnChangeFromValue", Name: "Dato.CoAssicurazioneJSON", Value: GetSingleInsurance(data.Dato) });
            setProductBinder(data.Dato);

        }
    }

    const GetSingleInsurance = (productBinderJSON: string): string => {
        if (productBinderJSON) {
            const productBinder: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(productBinderJSON);

            if (productBinder.length == 1) {
                const coInsurance = new Dati.CDatoCoAssicurazione();
                coInsurance.Delegataria = true;
                coInsurance.Quota = 100;
                coInsurance.ID_Anag = productBinder[0].ID_AnagCompagnia;
                coInsurance.ID_Binder = productBinder[0].ID_Binder;
                coInsurance.ID_BinderCompagnia = productBinder[0].ID_BinderCompagnia;

                return JSON.stringify([coInsurance]);
            }
        }

        return "";
    };

    const GetFormData = (calculate = false, draft = false): Dati.CIngrAPI<Dati.CDatiPolizza> => {
        const formData = new Dati.CIngrAPI<Dati.CDatiPolizza>();

        formData.Dato = Data.Dato;
        formData.Dato.ID_AnagContraente = Number(ID_Anag);
        formData.Dato.ID_Polizza = Number(ID_Polizza);
        formData.Dato.DatiPolizza = JSON.stringify({ ...PolicyData });
        if (!calculate) {
            if (!draft) {
                formData.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Preventivo;
            } else {
                formData.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_PreventivoBozzaInviata;
            }
        }
        return formData;
    };

    const OnClickCalculate = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        OnRecalculateExtensions(data);
        if (!data.Errore) {
            ShowDialog("Info", Trad.Trad("Premio calcolato correttamente"), "success");
        }
    };

    const OnClickSave = (data: Dati.CRisAPI) => {

        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/polizzacar/${data.ID_Chiave}`);
            }
            const savedData = { ...Data };

            savedData.Dato.ID_Polizza = data.ID_Chiave;
            savedData.Dato.Polizza = data.MessaggioTesto;
            savedData.Dato.ContraenteATI = data.MessaggioDati[0];
            savedData.Dato.ID_TipoFileRichiesto = data.MessaggioDati[1];

            ShowDialog("POLIZZA", Trad.TradParam("Polizza salvata correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            setData({ Type: "Set", Value: savedData });
            history.push(`/anagrafica/${ID_Anag}/polizzacar/${data.ID_Chiave}`);
        }
    };

    const OnClickRelease = (data: Dati.CRisAPI) => {
        if (ID_Polizza == "0") {
            history.push(`/anagrafica/${ID_Anag}/polizzacar/${data.ID_Chiave}`);
        }
        const savedData = { ...Data };

        savedData.Dato.ID_Polizza = data.ID_Chiave;
        savedData.Dato.Polizza = data.MessaggioTesto;
        savedData.Dato.ContraenteATI = data.MessaggioDati[0];
        savedData.Dato.ID_TipoFileRichiesto = data.MessaggioDati[1];

        ShowDialog("POLIZZA", Trad.TradParam("Polizza emessa correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
        setData({ Type: "Set", Value: savedData });
        history.push(`/anagrafica/${ID_Anag}/polizzacar/${data.ID_Chiave}`);

    };

    const OnBlurAmount = () => {
        const newPolicy = { ...PolicyData };
        const hasExtensions = Object.keys(Data.Info).some(item => Data.Info[item].Campo == "ProrogheAccessori" || Data.Info[item].Campo == "ProrogheDa");
    };

    const OnChangeAmount = (e: string, val: string) => {
        const newPolicy = { ...PolicyData };
        const value = Number(val);

        switch (e) {
            case "CostoOpera":
                if (value > 2500000) {
                    ShowDialog("ERRORE", Trad.Trad("PremioImpostatoSuperioreAlLimite"), "error");
                    return;
                }
                newPolicy.Somme1 = value;
                newPolicy.Scoperto1 = 10;
                switch (true) {
                    case (value > 2500000):
                        newPolicy.ScopertoMinimo1 = 15000;
                        break;
                    case (value > 1000000):
                        newPolicy.ScopertoMinimo1 = 15000;
                        break;
                    case (value > 500000):
                        newPolicy.ScopertoMinimo1 = 10000;
                        break;
                    case (value > 250000):
                        newPolicy.ScopertoMinimo1 = 7500;
                        break;
                    case (value > 100000):
                        newPolicy.ScopertoMinimo1 = 5000;
                        break;
                    default:
                        newPolicy.ScopertoMinimo1 = 2500;
                        break;
                }
                break;
            case "Somme2":
                newPolicy.Scoperto2 = 10;
                switch (true) {
                    case (value > 250000):
                        newPolicy.ScopertoMinimo2 = 10000;
                        break;
                    case (value > 0):
                        newPolicy.ScopertoMinimo2 = 5000;
                        break;
                    default:
                        newPolicy.Scoperto2 = 0;
                        newPolicy.ScopertoMinimo2 = 0;
                        break;
                }
                break;
            case "GaranziaManutenzione":
                const dataFineLavori: Date = moment(newPolicy.DataFineLavori).toDate();
                const dataFineManutenzione: Date = new CData(dataFineLavori, true).AddMesi(Number(value)).Data;
                switch (value) {
                    case 12:
                        newPolicy.DataInizioManutenzione = newPolicy.DataFineLavori;
                        newPolicy.DataFineManutenzione = dataFineManutenzione;
                        break;
                    case 24:
                        newPolicy.DataInizioManutenzione = newPolicy.DataFineLavori;
                        newPolicy.DataFineManutenzione = dataFineManutenzione;
                        break;
                    default:
                        newPolicy.DataInizioManutenzione = null;
                        newPolicy.DataFineManutenzione = null;
                        break;
                }
                break;
            case "SezioneBLimit":
                newPolicy.ScopertoB = 10;
                switch (value) {
                    case 500000:
                        newPolicy.ScopertoMinimoB = 5000;
                        break;
                    case 750000:
                        newPolicy.ScopertoMinimoB = 7500;
                        break;
                    case 1000000:
                        newPolicy.ScopertoMinimoB = 10000;
                        break;
                    default:
                        newPolicy.ScopertoB = 0;
                        newPolicy.ScopertoMinimoB = 0;
                        break;
                }
                break;
            case "ID_ModalitaEmissione":
                switch (value) {
                    case 3:
                    case 4:
                        newPolicy.DirittiEmissione = 24.5;
                        break;
                    default:
                        newPolicy.DirittiEmissione = 0;
                        break;
                }
                newPolicy.Imposte = newPolicy.PremioFinito / (1 / Tax + 1);
                newPolicy.Imponibile = newPolicy.PremioFinito / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + newPolicy.Accessori) / 100);
                break;
            case "Accessori":
                newPolicy.Imposte = newPolicy.PremioFinito / (1 / Tax + 1);
                newPolicy.Imponibile = newPolicy.PremioFinito / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + value) / 100);
                break;
            case "PremioFinito":
                newPolicy.Imposte = value / (1 / Tax + 1);
                newPolicy.Imponibile = value / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + newPolicy.Accessori) / 100);
                break;
        }
        newPolicy[e] = val;
        setPolicyData({ Type: "Set", Value: newPolicy });
    };

    const OnChangeExtensions = (e: string, val: string) => {
        const newPolicy = { ...PolicyData };
        const value = Number(val);

        switch (e) {
            case "CostoOpera":
                newPolicy.Somme1 = value;
                newPolicy.Scoperto1 = 10;
                switch (true) {
                    case (value > 2500000):
                        newPolicy.ScopertoMinimo1 = 15000;
                        break;
                    case (value > 1000000):
                        newPolicy.ScopertoMinimo1 = 10000;
                        break;
                    case (value > 500000):
                        newPolicy.ScopertoMinimo1 = 7500;
                        break;
                    case (value > 250000):
                        newPolicy.ScopertoMinimo1 = 5000;
                        break;
                    case (value > 100000):
                        newPolicy.ScopertoMinimo1 = 2500;
                        break;
                    default:
                        newPolicy.ScopertoMinimo1 = 2500;
                        break;
                }
                break;
            case "Somme2":
                newPolicy.Scoperto2 = 10;
                switch (true) {
                    case (value > 250000):
                        newPolicy.ScopertoMinimo2 = 10000;
                        break;
                    case (value > 0):
                        newPolicy.ScopertoMinimo2 = 5000;
                        break;
                    default:
                        newPolicy.Scoperto2 = 0;
                        newPolicy.ScopertoMinimo2 = 0;
                        break;
                }
                break;
            case "SezioneBLimit":
                newPolicy.ScopertoB = 10;
                switch (value) {
                    case 500000:
                        newPolicy.ScopertoMinimoB = 5000;
                        break;
                    case 750000:
                        newPolicy.ScopertoMinimoB = 7500;
                        break;
                    case 1000000:
                        newPolicy.ScopertoMinimoB = 10000;
                        break;
                    default:
                        newPolicy.ScopertoB = 0;
                        newPolicy.ScopertoMinimoB = 0;
                        break;
                }
                break;
            case "ID_ModalitaEmissione":
                switch (value) {
                    case 3:
                    case 4:
                        newPolicy.DirittiEmissione = 24.5;
                        break;
                    default:
                        newPolicy.DirittiEmissione = 0;
                        break;
                }
                break;
            case "PremioFinito":
                newPolicy.Imposte = value / (1 / Tax + 1);
                newPolicy.Imponibile = value / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + newPolicy.Accessori) / 100);
                break;
        }
        newPolicy[e] = val;
        setPolicyData({ Type: "Set", Value: newPolicy });
    };

    const OnRecalculateExtensions = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            const newBondData = JSON.parse(data.Dato.DatiPolizza);

            setData({ Type: "Set", Value: data });
            setPolicyData({ Type: "Set", Value: newBondData });
        }
    };
    const ParametrsChangeState: { [Param: string]: any } = [];
    ParametrsChangeState["id_Polizza"] = ID_Polizza;


    const isFormValid = true;
    const showActionButtons = Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo
        || Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_PreventivoBozzaInviata
        || Data.Dato.ID_TipoPolizzaStato == "";

    //const showChangeStateButtons = Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa;
    let Sessione = Glob.GetSessione();
    const isCoverholder = Sessione.Gruppi.includes("7") || Sessione.Gruppi.includes("8") || Sessione.Gruppi.includes("9");

    return (
        <Card>
            <CardContent>
                <form noValidate autoComplete="off">
                    <_PolicyCARFormContent
                        Data={Data}
                        PolicyData={PolicyData}
                        Limits={Limits}
                        ProductBinderJSON={ProductBinder}
                        RiduzioneSommaGarantita={undefined}
                        OnBlurAmount={OnBlurAmount}
                        OnChangeAmount={OnChangeAmount}
                        OnChangeDerogation={OnChangeDerogation}
                        OnChangeBondData={(e, val) => setPolicyData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                        OnChange={(e, val) => setData({
                            Type: "OnChangeFromHybrid",
                            NameEvent: val != null && val != undefined ? e : Object.assign({}, e),
                            Value: val
                        })}
                    />
                </form>
            </CardContent>

            <CardActions disableSpacing>
                <Grid item container xs={12} spacing={3} justify="flex-end">
                    {editingRights && showActionButtons && (
                        <>
                            <Grid item>
                                <_ButtonAPI Testo={Trad.Trad("Calcola")} URL="/api/polizza/calculatecar"
                                    OnInvio={() => GetFormData(true)} OnClick={OnClickCalculate}
                                    OnErrore={OnApiError} />
                            </Grid>
                            <Grid item>
                                <_ButtonAPI Attivo={isFormValid} Testo={Trad.Trad("Salva")}
                                    URL="/api/polizza/salvapolizza?emission=false" OnInvio={GetFormData} OnClick={OnClickSave}
                                    OnErrore={OnApiError} />
                            </Grid>
                            {isCoverholder && (
                                <Grid item>
                                    <_ButtonAPI Default Attivo={isFormValid} Testo={Trad.Trad("Emetti")}
                                        URL="/api/polizza/salvapolizza?emission=true" OnInvio={GetFormData} OnClick={OnClickRelease}
                                        OnErrore={OnApiError} />
                                </Grid>
                            )}
                        </>
                    )}
                    {!showActionButtons && (
                        <Grid item>
                            <_Button Testo={Trad.Trad("Stampa")} Icona={<PrintIcon />}
                                OnClick={() => onPrint(false, Data.Dato)} Default={false} WithWrapper={false} />
                        </Grid>
                    )}
                    {showActionButtons && (
                        <Grid item>
                            <_Button Testo={Trad.Trad("Stampa bozza")} Icona={<PrintIcon />}
                                OnClick={() => onPrint(true, Data.Dato)} Default={false} WithWrapper={false} />
                        </Grid>
                    )}
                    {Number(ID_Polizza) > 0 && Object.keys(DerogationFieldsList).length > 0 &&
                        <_Derogation Data={DerogationFieldsList} Id={Number(ID_Polizza)} Type={Glob.Tipi_DT_Polizza} />}
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/PolicyCAR/PolicyCARForm.tsx